export default {
  advisors: "Advisor | Advisors",
  browseAdvisors: "Browse advisors in The Delta ecosystem",
  preferredFundingStage: "Preferred funding stage",
};
